import {
  ButtonSelect as ButtonSelectComponent,
  ButtonSelectControl,
  SelectDropdownListHeader,
} from '../../../Select'
import { Container } from '../../Container'
import { SELECTS_OPTIONS } from '../Selects.constants'
import { useSelectState } from '../Selects.hooks'

function ButtonSearchSelect() {
  const { handleClear, handleSelectItem, value } = useSelectState()

  return (
    <Container label='Sync button select with search input inside dropdown'>
      <ButtonSelectComponent
        Control={ButtonSelectControl}
        controlProps={{
          contentProps: {
            placeholderProps: {
              text: 'Select an option',
            },
          },
        }}
        listProps={{
          Header: SelectDropdownListHeader,
          headerProps: {
            SelectAll: null,
          },
        }}
        options={SELECTS_OPTIONS}
        style={{ width: 240 }}
        value={value}
        onClear={handleClear}
        onSelectItem={handleSelectItem}
      />
    </Container>
  )
}

export default ButtonSearchSelect
